import { render, staticRenderFns } from "./TransferTable.html?vue&type=template&id=402461dc&scoped=true&"
import script from "./TransferTable.js?vue&type=script&lang=js&"
export * from "./TransferTable.js?vue&type=script&lang=js&"
import style0 from "./TransferTable.scss?vue&type=style&index=0&id=402461dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402461dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VPagination,VRow})
